"use strict";

if (document.getElementById("js-vivatech2019")) {
  new Vue({
    delimiters: ['[[', ']]'],
    el: '#js-vivatech2019',
    data: {
      programm: null,
      events: [],
      index: 0,
      loading: false,
      delay: 70
    },
    mounted: function mounted() {
      this.initCarousel();
    },
    watch: {
      currentDate: function currentDate(data) {
        this.events = !data ? null : this.programm[data];
      }
    },
    computed: {
      currentDate: function currentDate() {
        return this.getDate(this.index);
      },
      previousDate: function previousDate() {
        return this.getDate(this.index - 1, 4);
      },
      nextDate: function nextDate() {
        return this.getDate(this.index + 1, 4);
      }
    },
    methods: {
      initCarousel: function initCarousel() {
        var _this = this;

        this.programm = JSON.parse(this.$refs.carousel.getAttribute('data-programm'));
        setTimeout(function () {
          return _this.toggleCollapsesHidden();
        }, 200);
      },

      /***********************************
      GET DATA
      ***********************************/
      //Get index if in array
      getIndex: function getIndex(index) {
        return !this.programm || index < 0 || index > Object.keys(this.programm).length - 1 ? -1 : index;
      },
      //Get date depending on index or null
      getDate: function getDate(slide, substr) {
        var index = this.getIndex(slide);

        if (index != -1) {
          var value = Object.keys(this.programm)[index];
          return substr ? value.substr(0, value.length - substr) : value;
        } else {
          return null;
        }
      },

      /***********************************
      ACTIONS
      ***********************************/
      toggleCollapse: function toggleCollapse(i) {
        var collapses = this.$refs.collapse;
        collapses.forEach(function (d) {
          d.classList.remove('is-active');
        });
        collapses[i].classList.toggle('is-active');
      },
      toggleCollapsesHidden: function toggleCollapsesHidden(end) {
        var _this2 = this;

        var collapses = this.$refs.collapse;

        if (end) {
          this.toggleCollapse(0);
        }

        collapses.forEach(function (d, i) {
          setTimeout(function () {
            return d.classList.toggle('is-hidden');
          }, i * _this2.delay);

          if (i == collapses.length - 1 && end) {
            _this2.loading = false;
          }
        });
      },
      goTo: function goTo(nextIndex, index) {
        var _this3 = this;

        if (nextIndex && !this.loading) {
          var collapseLength = this.$refs.collapse.length;
          this.loading = true;
          this.index = index;
          this.toggleCollapsesHidden();
          setTimeout(function () {
            return _this3.toggleCollapsesHidden(true);
          }, collapseLength * this.delay);
        }
      },
      //Get index if in array
      prev: function prev() {
        /*if ((this.index - 1) < 0) {
          this.index = Object.keys(this.programm).length;
        }*/
        this.goTo(this.previousDate, this.index - 1);
      },
      next: function next() {
        /*if ((this.index + 1) > Object.keys(this.programm).length - 1) {
          this.index = -1;
        }*/
        this.goTo(this.nextDate, this.index + 1);
      },
      scrollTo: function scrollTo(ref) {
        $(this.$refs[ref]).velocity('scroll', {
          duration: 700,
          easing: 'ease-in-out'
        });
      }
    }
  });
}
/********
ANIMATION
*********/


$(function () {
  if ($('.vivatech2019-to-draw').length) {
    $('.vivatech2019-to-draw .js-letter').velocity({
      opacity: 0,
      translateX: -20
    }, 0);
    $('.vivatech2019-to-draw .js-letter').delay(1000).each(function (i) {
      var that = $(this),
          delay = 70 * i;
      that.velocity({
        opacity: 1,
        translateX: 0
      }, {
        duration: 1000,
        delay: delay,
        easing: [0.250, 0.250, 0, 1]
      });
    });
    $('.vivatech2019-to-draw .line').velocity({
      opacity: 0,
      translateY: -20
    }, 0);
    $('.vivatech2019-to-draw .line').delay(2000).each(function (i) {
      var that = $(this),
          delay = 200 * i;
      that.velocity({
        opacity: 1,
        translateY: 0
      }, {
        duration: 1000,
        delay: delay,
        easing: [0.250, 0.250, 0, 1]
      });
    });
  }
});